/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfacebook1Inputs */

const en_crosspostingfacebook1 = /** @type {(inputs: Crosspostingfacebook1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

const de_crosspostingfacebook1 = /** @type {(inputs: Crosspostingfacebook1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

/**
* | output |
* | --- |
* | "Facebook" |
*
* @param {Crosspostingfacebook1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfacebook1 = /** @type {((inputs?: Crosspostingfacebook1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfacebook1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfacebook1(inputs)
	return de_crosspostingfacebook1(inputs)
});
export { crosspostingfacebook1 as "crosspostingFacebook" }